import { render, staticRenderFns } from "./PlusProductionModal.vue?vue&type=template&id=c25415e0&scoped=true"
import script from "./PlusProductionModal.vue?vue&type=script&lang=ts"
export * from "./PlusProductionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25415e0",
  null
  
)

export default component.exports